'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { keyboardFocusShadow } from '../../mixins/keyboardFocus.js';
import { textStyle } from '../../mixins/textStyle.js';
import { useTitanRouter } from '../../router/hooks/useTitanRouter.js';
import { Clickable } from '../Clickable/Clickable.js';
import { LogoEls } from './LogoEls.js';
import { LogoSdu } from './LogoSdu.js';

const BrandName = styled.span.withConfig({
  componentId: "sc-y677c2-0"
})(["", ";font-family:", ";color:", ";margin-left:", ";"], textStyle('labelTinyBold'), ({
  theme
}) => theme.components.logo.fontFamily, ({
  theme
}) => theme.components.logo.textColor, ({
  theme
}) => theme.components.logo.brandMargin);
const sharedLogoStyles = css(["display:flex;align-items:center;text-decoration:none;color:", ";padding:", " 0;svg{flex-shrink:0;display:block;}", ""], ({
  theme
}) => theme.components.logo.brandColor, ({
  theme
}) => theme.components.logo.logoPadding, keyboardFocusShadow());
const StyledLogoButton = styled(Clickable).withConfig({
  componentId: "sc-y677c2-1"
})(["", ""], sharedLogoStyles);
const StyledLogoLink = styled.a.withConfig({
  componentId: "sc-y677c2-2"
})(["", ""], sharedLogoStyles);
const Logo = /*#__PURE__*/withTitan(({
  brandName,
  className,
  onClick,
  size = 32,
  svg,
  testId = 'logo',
  to = '/'
}) => {
  const {
    linkWrapper
  } = useTitanRouter();
  const children = jsxs(Fragment, {
    children: [svg || jsx(LogoSdu, {
      size: size
    }), brandName && jsx(BrandName, {
      children: brandName
    })]
  });
  return onClick ? jsx(StyledLogoButton, {
    className: className,
    "data-test-id": testId,
    onClick: onClick,
    children: children
  }) : linkWrapper(jsx(StyledLogoLink, {
    className: className,
    "data-test-id": testId,
    href: to,
    children: children
  }));
}, {
  name: 'Logo'
});
const LogoELS = /*#__PURE__*/withTitan(_a => {
  var {
      testId = 'logoELS',
      to = 'https://www.lefebvre-sarrut.eu/'
    } = _a,
    rest = __rest(_a, ["testId", "to"]);
  return jsx(Logo, Object.assign({}, rest, {
    svg: LogoEls,
    testId: testId,
    to: to
  }));
}, {
  name: 'LogoELS'
});

export { Logo, LogoELS };
//# sourceMappingURL=Logo.js.map
